import React, { Component } from 'react'
import styled from 'styled-components'
import ResetPasswordForm from 'components/auth/ResetPasswordForm'
import LogoTip from '../../components/UI/LogoTip/index.js'

class ResetPasswordPage extends Component {
  render() {
    return (
      <CenteredBlock>
        <LogoTip />
        <ResetPasswordForm />
      </CenteredBlock>
    )
  }
}

export default ResetPasswordPage

const CenteredBlock = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

// const LogoTip = styled.div`
//   //background: #fff;
//   // background: url(${logo});
//   background-size: cover;
//   width: 100px;
//   height: 100px;
//   margin-bottom: 1.5rem;
// `
